import React, { Component } from 'react';
import {Link, Redirect} from 'react-router-dom';

import { connect } from "react-redux";
import * as playlistReducers from "../../reducers/playlist";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';

import $ from "jquery";
import { Modal, ModalBody, ModalFooter, Button} from 'reactstrap';

import QRCode from 'qrcode.react';
import Loader from 'react-loader-spinner';
import {IMGIX_PATH, PUB_PLAYER_PATH, UNPUB_PLAYER_PATH} from "../../constants";
import UploadFile from '../includes/UploadFile';
import NewPlaylist from "./NewPlaylist";
import * as uploadReducers from "../../reducers/upload";

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
class PlaylistDetailContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            userDet : JSON.parse(window.localStorage.userDet),
            backtoPlaylist : false,
            showDuplicatedPlaylist : false,
            image_path: null,
            detUrl : false
        };

        this.playlistDetail = this.playlistDetail.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.editPlaylist = this.editPlaylist.bind(this);
        this.csToggle = this.cstoggle.bind(this);
        this.deletePlaylist = this.deletePlaylist.bind(this);
        this.createDuplicatePlaylist = this.createDuplicatePlaylist.bind(this);
        this.confirmRemove =this.confirmRemove.bind(this);
        this.removeFromPlaylist=this.removeFromPlaylist.bind(this);
        this.showSharePop = this.showSharePop.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.qToggle = this.qToggle.bind(this);
        this.cToggle = this.cToggle.bind(this);
        this.dToggle = this.dToggle.bind(this);
        this.rToggle = this.rToggle.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.showQRModal = this.showQRModal.bind(this);
        this.downloadQRCode = this.downloadQRCode.bind(this);
    }

    componentWillMount() {

        $(".modal-backdrop").hide();
    }

    componentDidMount() {
        this.playlistDetail();
        this.playlistVignets();

        this.setState({plId: this.props.match.params.id});
        $('.menu-icon').click(function() {
            $(this).closest('.side-menu-icon').find('.toggle-flip').slideToggle('active');
        });

        /*$(document).on("click", function(event){
            var $trigger = $(".side-menu-icon ");
            if($trigger !== event.target && !$trigger.has(event.target).length){
                $(".toggle-flip").slideUp("medium");
            }
        });*/

    }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if( prevProps.playlistData.vignetsList !== this.props.playlistData.vignetsList ) {
            $('.toggle-ico').off("click").on("click",function() {
                $(this).closest('.toggles-block').find('.toggle-flip').slideToggle('active');
            });
            $('.vig-share').off("click").on("click",function() {
                $(this).parent().find('.upload').slideToggle('active');
            });
        }

        if( this.props.playlistData.resetPlaylist === true && prevProps.playlistData.resetPlaylist !== this.props.playlistData.resetPlaylist) {
            this.setState({backtoPlaylist : true})
        }

        if(this.props.playlistData.playlistUpdated !== prevProps.playlistData.playlistUpdated ) {
            //this.playlistDetail();
            this.playlistVignets();
        }

        if(this.props.playlistData.detailSaved !== prevProps.playlistData.detailSaved ) {
            this.playlistDetail();
        }

        if(this.props.playlistData.newImage !== prevProps.playlistData.newImage ) {
            this.setState({image_path : this.props.playlistData.newImage});
        }

        console.log(this.props.playlistData.plDuplicated+"-----"+prevProps.playlistData.plDuplicated+"----------"+this.props.playlistData.playlistId+"----------"+prevProps.playlistData.playlistId);
        if(this.props.playlistData.plDuplicated !== prevProps.playlistData.plDuplicated && this.props.playlistData.playlistId !== prevProps.playlistData.playlistId) {
            this.setState({detUrl : "/playlist/"+this.props.playlistData.playlistId, showConfirmSimilar : false});
            //return <Redirect exact to={this.state.detUrl} />;
            window.location.reload();

        }
        
    }


    playlistDetail(){
        let data = { 'plId' : this.props.match.params.id  };
        this.props.getPlaylist(data);
    }

    playlistVignets(){
        let data = { 'plId' : this.props.match.params.id  };
        this.props.getPlaylistVignets(data);
    }
    editPlaylist() {
        this.props.showPlaylistModal();
    }


    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    removeFromPlaylist() {
        let data = {plid : this.props.playlistData.playlistId, vigid : this.state.vignetId}
        this.props.removeFromPlaylist(data);
        this.setState({showConfirmRemove : false});
    }

    confirmDelete() {
        this.setState({showConfirmDelete : true})
        /*let data = {plId : this.props.playlistData.playlistId}
        this.props.deletePlaylist(data);*/
    }
    cstoggle() {
        this.setState({showConfirmSimilar : !this.state.showConfirmSimilar});
    }

    dToggle() {
        this.setState({showConfirmDelete : !this.state.showConfirmDelete})
    }

    rToggle() {
        this.setState({showConfirmRemove : !this.state.showConfirmRemove})
    }

    deletePlaylist() {
        let data = {plId : this.props.playlistData.playlistId}
        this.props.deletePlaylist(data);
    }

    createDuplicatePlaylist(){
        let data = {plId : this.props.playlistData.playlistId, user_id : this.state.userDet.user_id}
        this.props.duplicatePlaylist(data);
    }

    confirmDuplicate() {
        this.setState({showConfirmSimilar : true})
        /*let data = {plId : this.props.playlistData.playlistId}
        this.props.deletePlaylist(data);*/
    }

    confirmRemove(vignetId){
        this.setState({showConfirmRemove : true,
            vignetId :vignetId})
    }

    showSharePop(vignet_id) {
        $("#vig-upload"+vignet_id).find('.upload').slideToggle('active');
    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
    }

    cToggle() {
        this.setState({
            copyUrl: !this.state.copyUrl
        });
    }

    qToggle() {
        console.log(this.state.showQR);
        this.setState({
            showQR: !this.state.showQR
        });
    }

    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.state.userDet.user_id;

        var e = document.createElement("textarea");
        var url ="https://a.vignets.com/react-vignet/player/?"+vigID+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {


        var baseUrl =String('https://a.vignets.com/react-vignet/player/?'+vignet_id);

        let rootUrl = '';let shareUrl ='';


        if(type == 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type == 'wa') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type == 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }
        window.open(shareUrl,'_blank');

    }

    /*********** Scan QR code of vignet********/
    showQRModal(vigID)
    {
        this.setState({
            showQR : true
        });

    }

    downloadQRCode() {
        let vignet_id = this.state.vignet_id;
        var canvas = document.querySelector( 'canvas' );
        var link = document.createElement('a');
        link.innerHTML = 'Download';
        link.addEventListener('click', function(ev) {
            link.href = canvas.toDataURL();
            link.download = vignet_id+".png";
        }, false);
        document.body.appendChild(link);
        link.click();
    }


    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        //Request to purging
        this.props.getImagepurged({image_name : this.state.plId});

    }

    render() {

        if (this.state.backtoPlaylist) {
            return <Redirect exact to='/playlists'/>;
        }

        if(this.state.detUrl && this.props.match.url !== '/playlist/'+this.props.playlistData.playlistId ) {
            return <Redirect exact to={this.state.detUrl} />;
        }

        let playlist = this.props.playlistData? this.props.playlistData.playListDetail:undefined;
        let vignetsList = this.props.playlistData? this.props.playlistData.vignetsList:undefined;
        let vignetIds = this.props.playlistData? this.props.playlistData.vignetIds:[];
        let img_name= 'no-image';
        let playerUrl = '';
        if(playlist) {
            img_name = playlist.pl_id;
        }
        /*if(item) {
            item.playerUrl = PLAYER_PATH+ item.vignet_id;
        }*/

        console.log(playlist);

        let imgSrc = IMGIX_PATH+'assets/slider/'+img_name+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';



            console.log(vignetsList);


        return (

            <div className="list-wrap wrap-style ply-wrp">
                <div className="right-content-section">
                    <div className="bottom-title">
                        <div className=" side-menu-icon">
                            <button className="icon-lib-list menu-icon"></button>
                            <ul className="toggle-flip">
                                <li>
                                    <a href="javascript:void(0);" className="icon-lib" onClick={()=>this.editPlaylist()}>Edit Details</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" className="icon-lib" onClick={()=>this.confirmDuplicate()}>Create Similar Playlist</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" className="last-row icon-lib" onClick={()=>this.confirmDelete()}>Delete this Playlist</a>
                                </li>
                            </ul>
                        </div>
                        <div className="image-upload-block-playlist">
                            <div className="image-up-playlist">
                                {this.state.image_path &&
                                <img src={this.state.image_path} crossOrigin="anonymous"
                                     className="text-center" alt="user"/>
                                }
                                {this.state.image_path === null &&
                                <img src={imgSrc} alt="default"/>
                                }

                                <UploadFile getUploadedFile={this.getUploadedFile.bind(this)} type="add" progress="progress-bar-wrapper1"
                                            item_type="PLAYLIST" unique_id = {(this.props.playlistData && this.props.playlistData.playListDetail && this.props.playlistData.playListDetail.pl_id) ? this.props.playlistData.playListDetail.pl_id : ''} />
                                {this.props.uploadData.loader === true &&
                                <div id="progress-bar-wrapper1"></div>
                                }
                                {this.props.uploadData.errors === true &&
                                <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                }
                            </div>
                        </div>
                        {playlist &&
                        <div className="title-content">
                            <h2>{playlist.pl_name}</h2>
                            <p className="title-sub-content-left">{playlist.created_date}<span className="title-sub-content">JAVIER LEWANDOWSKI</span>
                            </p>
                            <p className="title-desc">{playlist.pl_desc}</p>
                            <div className="title-icons">
                                <a href={"#/playlist/add/"+this.props.playlistData.playlistId} className="title-menu-icons" >
                                    <span className="ico-add"></span>
                                </a>
                                <a href={"#/view-playlist/"+playlist.pl_id} className="title-menu-icons" target="_blank">
                                    <span className="icon-lib-list ico-eye"></span>
                                </a>
                                {/*<a href="javascript:void(0);" className="title-menu-icons upload">
                                    <span className="icon-lib-list ico-upload"></span>
                                </a>*/}
                            </div>
                        </div>
                        }
                    </div>
                    <div className="content-table-sec">
                        <div className="vignet-table-block">
                            <table className="table vignet-table title-table">
                                <thead>
                                <tr>
                                    <th>VIGNETS</th>
                                    {/*<th>AUTHOR</th>
                                    <th>PLAYLIST</th>*/}
                                </tr>
                                </thead>
                                <tbody className="table-body-section">
                                {!vignetsList &&
                                <tr>
                                    <td colSpan="3">
                                        <div className="loaderWrapper">
                                            <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/></div>
                                    </td>
                                </tr>
                                }

                                {vignetsList && vignetsList.length > 0 && vignetsList.map((item,index) =>{
                                        let imgSrc = IMGIX_PATH+'assets/slider/cf'+item.vignet_id+'.jpg';

                                        if(item.public_view === 1) {
                                            item.playerUrl = PUB_PLAYER_PATH+ item.vignet_id;
                                        }
                                        else{
                                            item.playerUrl = UNPUB_PLAYER_PATH+ item.vignet_id;
                                        }

                                        return(
                                            <tr>
                                                <td>
                                                    <div className="report-img">
                                                        <img src={imgSrc} />
                                                    </div>
                                                    {item.vignet_title}
                                                    <div className="toggles-block">
                                                        <button className="toggle-ico"></button>
                                                        <ul className="toggle-flip">
                                                            <li id={"vig-upload"+item.vignet_id}>
                                                                <a href="javascript:void(0);"
                                                                   className="icon-lib side-arrow vig-share" onClick={()=>this.showSharePop()}>Share</a>
                                                                <ul className="upload">
                                                                    <li>
                                                                        <a href="javascript:void(0);" className="icon-lib icon-face" onClick={() => {this.shareToFb('fb',item.vignet_id)}}>Facebook</a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0);" className="icon-lib icon-whatsapp" onClick={() => {this.shareToFb('wa',item.vignet_id)}}>Whatsapp</a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0);" className="icon-lib icon-email" onClick={() => {this.shareToFb('em',item.vignet_id, item.vignet_title)}}>Email</a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0);" className="icon-lib icon-embed" onClick={() => {this.showWebModal(item.vignet_id, item.vignet_title)}}>Copy Embed Code</a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0);" className="icon-lib icon-qr" onClick={() => {this.showQRModal(item.vignet_id)}}>QR Code</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                            <li>
                                                                <a href={item.playerUrl} target="_blank" className="icon-lib">Go to Author</a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="last-row icon-lib" onClick={() => {this.confirmRemove(item.vignet_id)}}>Remove
                                                                    from this Playlist</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }


                                )}

                                </tbody>
                            </table>
                            {vignetsList && vignetsList.length === 0 &&
                            <div className="new-page-content">
                                <div className="new-page-wrap">
                                    <h1>This playlist is currently empty</h1>
                                    <p>Start adding Vignets to this playlist</p>
                                    <div className="button-new-block">
                                        <Link to={"/playlist/add/"+this.props.playlistData.playlistId}><button className="vig-list-button">GO TO VIGNETS LIST</button></Link>
                                    </div>
                                </div>
                            </div>
                            }

                        </div>
                        <div className="table-header">
                            <p className="header-content-right">vignets</p>
                            <p className="header-content-right">Total duration</p>
                        </div>
                    </div>
                </div>
                <NewPlaylist/>

                <Modal isOpen={this.state.showConfirmDelete} id="delete-playlist">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to delete the playlist?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.dToggle}>Cancel</Button>
                        <Button color="primary" onClick={this.deletePlaylist}>Confirm</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.showConfirmSimilar} id="similar-playlist">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to create similar playlist?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.csToggle}>Cancel</Button>
                        <Button color="primary" onClick={this.createDuplicatePlaylist}>Confirm</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showConfirmRemove} id="remove-playlist">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Do you want to remove the vignet from the playlist?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.rToggle}>Cancel</Button>
                        <Button color="primary" onClick={this.removeFromPlaylist}>Confirm</Button>
                    </ModalFooter>
                </Modal>

                {this.state.copyUrl &&

                <Modal isOpen={this.state.copyUrl} toggle={this.cToggle} >
                    <ModalBody>
                        <div className="alert alert-danger text-center" role="alert">
                            The link copied to clipboard. {this.state.copyUrl}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.cToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }



                {this.state.showQR &&

                <Modal isOpen={this.state.showQR} toggle={this.qToggle} >
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">

                            <QRCode value=""/>

                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.downloadQRCode}>Download</Button>
                        <Button color="secondary" onClick={this.qToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }
            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        playlistData  :playlistReducers.getPlaylistData(state),
            uploadData : uploadReducers.getUploadData(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    getPlaylist : playlistActions.getPlayListDetails,
    getPlaylistVignets : playlistActions.showPlaylistVignets,
    showPlaylistModal : playlistActions.showPlaylistModal,
    removeFromPlaylist : playlistActions.removeFromPlaylist,
    deletePlaylist : playlistActions.deletePlaylist,
    duplicatePlaylist : playlistActions.duplicatePlaylist,
    getImagepurged : playlistActions.purgeImage
})(PlaylistDetailContainer));



// WEBPACK FOOTER //
// ./src/components/playlist/DetailContainer.js